<div class="grid field col-12">
  <div class="grid field col-12">
    @if (!ready) {
      <p-progressSpinner></p-progressSpinner>
    }
    @if (ready) {
      <app-job-linker
        [forAdmin]="true"
        [companySelectItems]="companySelectItems"
        [vendorJobSelectItems]="vendorJobSelectItems"
        [consumerJobs]="consumerJobs">
      </app-job-linker>
    }
  </div>
</div>
